<template>
  <div>
    <div class="module-wrap">
      <div class="footer-common-line"></div>
      <a href="tel: 010-63052088"
         class="footer-common">
        服务热线： 010-63052088
      </a>
      <p style="font-size:13px"
         class="footer-common-pd24 footer-common-f12 footer-common-copyright">Copyright2023
        北京华卫通科健康科技有限公司版权所有</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mobile_footer',
  data () {
    return {};
  }
};
</script>

<style>
.module-wrap {
    padding-bottom: 0.26666667rem;
    background-color: #373d41;
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 100%;
}

.hot-product {
    padding: 0.4rem 0.53333333rem;
}

.footer-common-line {
    margin: 0 0.21333333rem;
    height: 1px;
    background-color: #5b5b5b;
    transform: scaleY(0.5);
}

.footer-common {
    border: 1px solid #979797;
    display: block;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    color: #ebecec;
    margin: 0.53333333rem 0.50666667rem;
}

.footer-common-copyright {
    color: #d7d8d9;
    text-align: center;
}
</style>
